import React, { Fragment } from "react";
import {
  Type,
  Input,
  Button,
  Select,
  ValidationMessaging,
  Alert,
  Field,
  Spinner,
  InputCheckbox,
  Anchor,
} from "discover.medical.react-component-library";
import Captcha from "../../captcha";
import PasswordTooltip from "./password-tooltip";
import { MedicalSpecialties, NursingSpecialties } from "./specialties";
import { MedicalRoles, NursingRoles } from "./roles";
import "./index.css";
import {
  getConstraints,
  containsExcludedWords,
  matchesLengthRegex,
  matchesNumberRegex,
  matchesSpecialCharRegex,
} from "./validation";
import { PasswordValidationMessaging } from "./password-validation-messaging";
import { SignInNow } from "./sign-in-now";
import MessageDialog from "./message-dialog";
import TermsOfUse from "../../termsOfUse";

var validate = require("validate.js");

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      firstname: "",
      lastname: "",
      organization: "",
      specialty: "",
      role: "",
      errors: {},
      webAuthError: "",
      isSubmitDisabled: false,
      captcha: null,
      showLoginLink: false,
      termsOfUseChecked: false,
      isOpen: false,
      termsOfUseCheckedError: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.showLoginScreenWithSuccessMessage =
      this.showLoginScreenWithSuccessMessage.bind(this);
    this.captchaRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.webAuth && this.captchaRef.current) {
      this.setState({
        captcha: this.props.webAuth.renderCaptcha(this.captchaRef.current),
      });
    }
  }

  showLoginScreenWithSuccessMessage = () => {
    const { onFormChange, setUserName, setSuccessMessage } = this.props;
    const username = this.state.username;
    setUserName(username);
    setSuccessMessage(
      "Your account was successfully created. Please Sign In below."
    );
    onFormChange("login");
  };

  handleTermsOfUseCheckboxEvent = () => {
    this.setState({
      termsOfUseChecked: !this.state.termsOfUseChecked,
    });
  };

  closeTermsOfUseModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  openTermsOfUseModal = () => {
    this.setState({ termsOfUseCheckedError: false });
    this.setState({
      isOpen: true,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  resetErrors() {
    this.setState({ errors: {} });
    this.setState({ webAuthError: "" });
    this.setState({ showLoginLink: false });
    this.setState({ termsOfUseCheckedError: false });
  }

  getValidationMessage(inputName) {
    const errors = this.state.errors[inputName];
    let message = "";
    if (errors) {
      for (let i = 0; i < errors.length; i++) {
        message = message + errors[i] + "\n";
      }
    }
    return message;
  }

  validatePassword() {
    validate.validators.password = (value, options) => {
      if (!value) {
        value = "";
      }

      // make sure pw doesn't contain excluded words
      const hasExcludedWords = containsExcludedWords(value);
      // make sure pw matches regex
      const isMatchRegexp =
        matchesNumberRegex(value) &&
        matchesLengthRegex(value) &&
        matchesSpecialCharRegex(value);

      if (hasExcludedWords || !isMatchRegexp) {
        return options.message;
      }
    };
  }

  validateForm() {
    let form = document.querySelector("form#register_form");
    let constraints = getConstraints(this.props.organizationContext);
    return validate(form, constraints);
  }

  register() {
    const { webAuth, databaseConnection, organizationContext, contextToken } =
      this.props;
    if (!webAuth) {
      return;
    }

    const signupBody = {
      connection: databaseConnection,
      email: this.state.username,
      password: this.state.password,
      user_metadata: {
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        organization: this.state.organization || organizationContext,
        specialty: this.state.specialty,
        role: this.state.role,
      },
      captcha: this.state.captcha.getValue(),
    };

    webAuth.signup(signupBody, (error) => {
      if (!error) {
        //If sign up is successful attempt to auto login
        const userName = this.state.username;
        const login = contextToken ? `${contextToken}@@@${userName}` : userName;
        webAuth.login(
          {
            realm: databaseConnection,
            username: login,
            password: this.state.password,
          },
          (loginError) => {
            // If auto login failed show them the login screen so they can login
            this.showLoginScreenWithSuccessMessage();
          }
        );
        return;
      }

      this.state.captcha.reload();

      // User Already Exists
      if (error.statusCode === 400 && error.code === "user_exists") {
        this.setState({ isSubmitDisabled: false });
        this.setState({ showLoginLink: true });
        this.setState({ webAuthError: "You already have an account.  " });

        // Wrong username or password
      } else if (error.code === "wrongusernameorpassword") {
        //if wrongusernameorpassword error during signup, then login failed
        //but user creation succeeded, so toggle the login with message
        this.setState({ showLoginLink: false });
        this.showLoginScreenWithSuccessMessage();

        // Other Error
      } else {
        this.setState({ showLoginLink: false });
        if (typeof error.description === "object") {
          this.setState({
            webAuthError: "Sorry, something went wrong. Please try again.",
          });
        } else {
          this.setState({ webAuthError: error.description });
        }
        //re-enable button if error occurs
        this.setState({ isSubmitDisabled: false });
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.resetErrors();
    this.setState({ isSubmitDisabled: true });

    // check for input errors for pw
    const passwordError = this.validatePassword();
    if (passwordError) {
      return passwordError;
    }

    // check for input errors in the form
    const formErrors = this.validateForm();

    if (formErrors) {
      this.setState(
        {
          errors: formErrors,
          termsOfUseCheckedError: !this.state.termsOfUseChecked,
        },
        () => {
          this.setState({ isSubmitDisabled: false });
        }
      );
      return;
    } else if (!this.state.termsOfUseChecked) {
      this.setState(
        { termsOfUseCheckedError: !this.state.termsOfUseChecked },
        () => {
          this.setState({ isSubmitDisabled: false });
        }
      );
    }

    // register via auth0 web auth
    this.register();
  }
  render() {
    const { onFormChange, organizationContext, productName, eisSource } =
      this.props;
    const { isSubmitDisabled, errors, webAuthError, showLoginLink } =
      this.state;
    const isRequiredPasswordError =
      errors.password && errors.password[0] === "Required";
    // Don't show this dialog unless EHR and anything other than DH
    const shouldShowMessageDialog =
      eisSource === "ehr" && ["dcd", "dsd"].includes(productName);

    // Create the list of Roles based on product with the first one being empty
    const roles = [{ value: "", label: "Choose a role" }];
    (productName === "dh" ? NursingRoles : MedicalRoles).forEach((value) => {
      roles.push({ value: value, label: value });
    });

    // Create the list of Specialties based on product with the first one being empty
    const specialties = [{ value: "", label: "Choose a specialty" }];
    (productName === "dh" ? NursingSpecialties : MedicalSpecialties).forEach(
      (value) => {
        specialties.push({ value: value, label: value });
      }
    );

    return (
      <div className="Form" data-testid="register-form">
        <MessageDialog isDialogOpen={shouldShowMessageDialog} />
        <div className="Form__header">
          <Type element="h2" fontFamily="secondary" marginBottom="sm">
            Register for a personal account
          </Type>
          <Type
            element="i"
            fontSize="sm"
            display="inline-block"
            marginBottom="sm"
          >
            Already have a personal account?{" "}
            <SignInNow onFormChange={() => onFormChange("login")} />
          </Type>
          {organizationContext && (
            <Type
              className="org_context_banner"
              element="p"
              fontSize="sm"
              marginBottom="sm"
            >
              Signing up here will affiliate your account with{" "}
              <Type element="strong" fontSize="sm">
                {organizationContext}
              </Type>{" "}
              and give you access to their subscribed content.
            </Type>
          )}
        </div>
        {webAuthError && (
          <Alert className="Form__alert" type="error">
            <Type element="p">
              {webAuthError}
              {showLoginLink && (
                <SignInNow onFormChange={() => onFormChange("login")} />
              )}
            </Type>
          </Alert>
        )}
        {isSubmitDisabled && <Spinner size="lg" role="spinner" />}
        <form id="register_form" className="Form__body" onSubmit={this.handleSubmit}>
          <Field
            id="username"
            data-testid="username"
            label="Email Address"
            hasError={!!errors.username}
            message={
              <ValidationMessaging hasError={!!errors.username}>
                {this.getValidationMessage("username")}
              </ValidationMessaging>
            }
          >
            <Input.Text
              name="username"
              autoComplete="username"
              value={this.state.username}
              onChange={this.handleChange}
              hasError={!!errors.username}
            />
          </Field>

          <Field
            id="password"
            data-testid="password"
            label="Password"
            hasError={!!errors.password}
            message={
              <PasswordValidationMessaging
                password={this.state.password}
                isRequiredPasswordError={isRequiredPasswordError}
              />
            }
          >
            <PasswordTooltip />
            <Input.Text
              className="Register__password"
              name="password"
              type="password"
              autoComplete="new-password"
              revealable={true}
              value={this.state.password}
              onChange={this.handleChange}
              hasError={!!errors.password}
            />
          </Field>
          <fieldset
            className="Fieldset"
          >
            <Type
              element="legend"
              fontFamily="secondary"
              display="block"
            >
              Your Information
            </Type>

            <Field
              id="firstname"
              data-testid="firstname"
              label="First Name"
              hasError={!!errors.firstname}
              message={
                <ValidationMessaging hasError={!!errors.firstname}>
                  {this.getValidationMessage("firstname")}
                </ValidationMessaging>
              }
            >
              <Input.Text
                name="firstname"
                value={this.state.firstname}
                onChange={this.handleChange}
                hasError={!!errors.firstname}
              />
            </Field>

            <Field
              id="lastname"
              data-testid="lastname"
              label="Last Name"
              hasError={!!errors.lastname}
              message={
                <ValidationMessaging hasError={!!errors.lastname}>
                  {this.getValidationMessage("lastname")}
                </ValidationMessaging>
              }
            >
              <Input.Text
                name="lastname"
                onChange={this.handleChange}
                value={this.state.lastname}
                hasError={!!errors.lastname}
              />
            </Field>

            {!organizationContext && (
              <Fragment>
                <Field
                  id="organization"
                  data-testid="organization"
                  label="Organization"
                  hasError={!!errors.organization}
                  message={
                    <ValidationMessaging hasError={!!errors.organization}>
                      {this.getValidationMessage("organization")}
                    </ValidationMessaging>
                  }
                >
                  <Input.Text
                    name="organization"
                    value={this.state.organization}
                    onChange={this.handleChange}
                    hasError={!!errors.organization}
                  />
                </Field>
              </Fragment>
            )}

            <Field
              id="specialty"
              data-testid="specialty"
              label="Specialty"
              hasError={!!errors.specialty}
              message={
                <ValidationMessaging hasError={!!errors.specialty}>
                  {this.getValidationMessage("specialty")}
                </ValidationMessaging>
              }
            >
              <Select
                name="specialty"
                value={this.state.specialty}
                onChange={this.handleChange}
                hasError={!!errors.specialty}
              >
                {specialties.map((specialty) => (
                  <Select.Option key={specialty.value} value={specialty.value}>
                    {specialty.label}
                  </Select.Option>
                ))}
              </Select>
            </Field>

            <Field
              id="role"
              data-testid="role"
              label="Role"
              hasError={!!errors.role}
              message={
                <ValidationMessaging hasError={!!errors.role}>
                  {this.getValidationMessage("role")}
                </ValidationMessaging>
              }
            >
              <Select
                name="role"
                value={this.state.role}
                onChange={this.handleChange}
                hasError={!!errors.role}
              >
                {roles.map((role) => (
                  <Select.Option key={role.value} value={role.value}>
                    {role.label}
                  </Select.Option>
                ))}
              </Select>
            </Field>
          </fieldset>
          <Type element="p" fontWeight="semibold" fontSize="sm" marginBottom="sm">
            Please read and agree to our&nbsp;
            <Anchor
              id="terms_of_use_link"
              data-testid="terms_of_use_link"
              href="#"
              fontSize="sm"
              onClick={this.openTermsOfUseModal}
            >
              Terms of Use
            </Anchor>
          </Type>
          <InputCheckbox
            label="I have read and agreed to all provisions outlined in the Terms of Use."
            name="terms_of_use_checkbox"
            id="terms_of_use_checkbox"
            data-testid="terms_of_use_checkbox"
            checked={this.state.termsOfUseChecked}
            onChange={this.handleTermsOfUseCheckboxEvent}
          />
          {this.state.termsOfUseCheckedError && (
            <div className="Register__warningWrapper">
              <ValidationMessaging hasError>
                <Type element="p" fontSize="sm" color="error">
                  Agreement to Terms of Use is required.
                </Type>
              </ValidationMessaging>
            </div>
          )}

          <Captcha className="Form__captcha" ref={this.captchaRef} />

          <Button
            id="register_button"
            className="Form__button"
            type="submit"
            disabled={isSubmitDisabled}
          >
            Register
          </Button>
        </form>
        <TermsOfUse
          isDlgOpen={this.state.isOpen}
          onClose={this.closeTermsOfUseModal}
          resourceUrl={this.props?.config?.resourceURL}
        ></TermsOfUse>
      </div>
    );
  }
}

export default RegisterForm;
